import { getAssetPurchaseOrderById } from '@api/services/asset-purchaase-order.service';
import useDataQuery from '@hooks/use-data-query';

const useAssetPurchaseOrderData = (
    clientInstallationId: string,
    projectInstallationId: string,
    purchaseOrderId: string
) => {
    const purchaseOrderQuery = useDataQuery(
        ['purchase-order', clientInstallationId, projectInstallationId, purchaseOrderId],
        () => getAssetPurchaseOrderById(clientInstallationId, projectInstallationId, purchaseOrderId),
        {
            enabled: Boolean(clientInstallationId && projectInstallationId && purchaseOrderId),
        }
    );

    return {
        isLoading: purchaseOrderQuery.isLoading,
        purchaseOrderData: purchaseOrderQuery.data,
        setData: purchaseOrderQuery.setData,
    };
};

export default useAssetPurchaseOrderData;
